/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type {QcUnsignedPackageDocumentTypesResponse} from '../models/QcUnsignedPackageDocumentTypesResponse';
import type {CancelablePromise} from '../core/CancelablePromise';
import type {BaseHttpRequest} from '../core/BaseHttpRequest';
export class QcUnsignedPackageDocumentTypeInternalService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * Returns the calling organization's configured Post-Closing QC unsigned-package document type ids.
   * @returns QcUnsignedPackageDocumentTypesResponse OK
   * @throws ApiError
   */
  public qcUnsignedPackageDocumentTypeInternalGetQcUnsignedPackageDocumentTypes(): CancelablePromise<QcUnsignedPackageDocumentTypesResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/internal/qc/unsigned-package-document-types',
      errors: {
        401: `Unauthorized`,
      },
    });
  }
}
